import { useState } from "react";
import { useRevealObserver, scrollToId } from "@/hooks/useRevealObserver";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import FocusEvents from "./components/FocusEvents";
import Categories from "./components/Categories";
import Picks from "./components/Picks";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";

export default function Home() {
  const [activeCat, setActiveCat] = useState<string>("all");

  useRevealObserver([]);

  const chooseCategory = (slug: string) => {
    setActiveCat(slug);
    scrollToId("hot");
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotRank activeCat={activeCat} setActiveCat={setActiveCat} />
        <FocusEvents />
        <Categories onChoose={chooseCategory} />
        <Picks />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}